"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_get_1 = __importDefault(require("lodash.get"));
var lodash_set_1 = __importDefault(require("lodash.set"));
var short_uuid_1 = __importDefault(require("short-uuid"));
var helpers_1 = require("./helpers");
var types_1 = require("./types");
/**
 * for each function in the schema
 * 1. subscribe to an event that the remote can call
 * 2. listen for calls from the remote. When called execute the function and emit the results.
 *
 * @param methods an array of method ids from the local schema
 * @param _connectionID
 * @return a function to cancel all subscriptions
 */
function registerLocalMethods(schema, methods, _connectionID, guest) {
    if (schema === void 0) { schema = {}; }
    if (methods === void 0) { methods = []; }
    var listeners = [];
    methods.forEach(function (methodName) {
        // handle a remote calling a local method
        function handleCall(event) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, action, callID, connectionID, callName, _b, args, payload, result, error_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = event.data, action = _a.action, callID = _a.callID, connectionID = _a.connectionID, callName = _a.callName, _b = _a.args, args = _b === void 0 ? [] : _b;
                            if (action !== types_1.actions.RPC_REQUEST)
                                return [2 /*return*/];
                            if (!helpers_1.isTrustedRemote(event))
                                return [2 /*return*/];
                            if (!callID || !callName)
                                return [2 /*return*/];
                            if (callName !== methodName)
                                return [2 /*return*/];
                            if (connectionID !== _connectionID)
                                return [2 /*return*/];
                            payload = {
                                action: types_1.actions.RPC_RESOLVE,
                                callID: callID,
                                callName: callName,
                                connectionID: connectionID,
                                error: null,
                                result: null,
                            };
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, lodash_get_1.default(schema, methodName).apply(void 0, args)];
                        case 2:
                            result = _c.sent();
                            payload.result = JSON.parse(JSON.stringify(result));
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _c.sent();
                            payload.error = JSON.parse(JSON.stringify(error_1, Object.getOwnPropertyNames(error_1)));
                            return [3 /*break*/, 4];
                        case 4:
                            if (guest)
                                guest.postMessage(payload);
                            else if (helpers_1.isWorker())
                                self.postMessage(payload);
                            else
                                event.source.postMessage(payload, event.origin);
                            return [2 /*return*/];
                    }
                });
            });
        }
        // subscribe to the call event
        if (guest)
            guest.addEventListener(types_1.events.MESSAGE, handleCall);
        else
            self.addEventListener(types_1.events.MESSAGE, handleCall);
        listeners.push(function () { return self.removeEventListener(types_1.events.MESSAGE, handleCall); });
    });
    return function () { return listeners.forEach(function (unregister) { return unregister(); }); };
}
exports.registerLocalMethods = registerLocalMethods;
/**
 * Create a function that will make an RPC request to the remote with some arguments.
 * Listen to an event that returns the results from the remote.
 *
 * @param _callName
 * @param _connectionID
 * @param event
 * @param listeners
 * @param guest
 *
 * @returns a promise with the result of the RPC
 */
function createRPC(_callName, _connectionID, event, listeners, guest) {
    if (listeners === void 0) { listeners = []; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            var callID = short_uuid_1.default.generate();
            // on RPC response
            function handleResponse(event) {
                var _a = event.data, callID = _a.callID, connectionID = _a.connectionID, callName = _a.callName, result = _a.result, error = _a.error, action = _a.action;
                if (!helpers_1.isTrustedRemote(event))
                    return;
                if (!callID || !callName)
                    return;
                if (callName !== _callName)
                    return;
                if (connectionID !== _connectionID)
                    return;
                // resolve the response
                if (action === types_1.actions.RPC_RESOLVE)
                    return resolve(result);
                if (action === types_1.actions.RPC_REJECT)
                    return reject(error);
            }
            // send the RPC request with arguments
            var payload = {
                action: types_1.actions.RPC_REQUEST,
                args: JSON.parse(JSON.stringify(args)),
                callID: callID,
                callName: _callName,
                connectionID: _connectionID,
            };
            if (guest)
                guest.addEventListener(types_1.events.MESSAGE, handleResponse);
            else
                self.addEventListener(types_1.events.MESSAGE, handleResponse);
            listeners.push(function () { return self.removeEventListener(types_1.events.MESSAGE, handleResponse); });
            if (guest)
                guest.postMessage(payload);
            else if (helpers_1.isWorker())
                self.postMessage(payload);
            else
                (event.source || event.target).postMessage(payload, event.origin);
        });
    };
}
exports.createRPC = createRPC;
/**
 * create an object based on the remote schema and methods. Functions in that object will
 * emit an event that will trigger the RPC on the remote.
 *
 * @param schema
 * @param methods
 * @param _connectionID
 * @param event
 * @param guest
 */
function registerRemoteMethods(schema, methods, _connectionID, event, guest) {
    if (schema === void 0) { schema = {}; }
    if (methods === void 0) { methods = []; }
    var remote = __assign({}, schema);
    var listeners = [];
    methods.forEach(function (methodName) {
        var rpc = createRPC(methodName, _connectionID, event, listeners, guest);
        lodash_set_1.default(remote, methodName, rpc);
    });
    return { remote: remote, unregisterRemote: function () { return listeners.forEach(function (unregister) { return unregister(); }); } };
}
exports.registerRemoteMethods = registerRemoteMethods;
//# sourceMappingURL=rpc.js.map